<app-page>
  <div class="container">
    <app-approval-admin-delivery-list></app-approval-admin-delivery-list>
  </div>
</app-page>
